import { Component, Injector, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Chart } from 'node_modules/chart.js';
import { Asegurado } from 'src/app/Models/asegurado-detalle';
import { Seguro } from 'src/app/Models/seguro';
import { AppInsightsService } from 'src/app/Services/appInsight.service';
import { SeisMeses } from '../../Models/seis-meses';

@Component({
  selector: 'app-meses-recorridos',
  templateUrl: './meses-recorridos.component.html',
  styleUrls: ['./meses-recorridos.component.css']
})
export class MesesRecorridosComponent implements OnChanges{
  @Input()
  item: SeisMeses;
  bar: any;
  ctx: any;
  barChart: any;
  blueGradientColor: any;
  show: boolean;
  asegurado: Asegurado;
  seguro: Seguro;

  isDataAvailable = false;
  constructor(private inj: Injector) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    for (const propName in changes) {
      if (propName === 'item') {
        if (this.item.thereIsKms){
            this.bar = document.getElementById('bar-chart');
            document.getElementById('bar-chart').removeAttribute('class');
            this.ctx = this.bar.getContext('2d');
            this.blueGradientColor = this.ctx.createLinearGradient(0, 0, 0, 300);
            this.blueGradientColor.addColorStop(1, '#0033A0');
            this.blueGradientColor.addColorStop(0, '#32C5FF');
            this.barChart = new Chart('bar-chart', {
              type: 'bar',
              data: {
                labels: this.item.months,
                datasets: [{
                  label: 'KM',
                  data: this.item.kms,
                  backgroundColor: this.blueGradientColor,
                  hoverBackgroundColor: this.blueGradientColor,
                  hoverBorderWidth: 2,
                  hoverBorderColor: '#0033A0',
                  barPercentage: 0.3
                }]
              },
              options: {
                legend: {
                  display: false
                },
                axisX: {
                  gridThickness: 5,
                  labelFontFamily: 'Barlow, sans-serif',
                },
                maintainAspectRatio: false,
                scales: {
                  yAxes: [{
                    ticks: {
                      beginAtZero: true
                    },
                  }]
                }
              }
            });
          }
        }
      }
    }
    logEventVerTodos(): void{
      this.asegurado = JSON.parse(localStorage.getItem('asegurado'));
      this.seguro = JSON.parse(localStorage.getItem('miSeguro'));
      let fechaHoy = new Date();
      const appInsightService = this.inj.get(AppInsightsService);
      appInsightService.logEvent(`Click en boton ver todos: (rut: ${this.asegurado.Rut}, Nombres y apellidos: ${this.asegurado.Nombre}, Patente: ${this.seguro.poliza.patente}, Fecha Hora: ${fechaHoy.toString()})`);
    }
  }
